import React from "react";
import "./ArticleData.css";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import config from "../../../Config/config";

const immunization = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const immunizationUrls = [
    {
      title: "ImmunizationUrls",
      urls: [
        {
          type: "pdf",
          url: `${config.apiURL}/uploads/articlespdfs/245453521061489663873.pdf`,
        },
        {
          type: "link",
          url: "https://www.unicef.org/india/stories/know-your-childs-vaccination-schedule",
          title: "Know your child's vaccination schedule | UNICEF India",
          description: "know your child's vaccination schedule",
        },
        {
          type: "pdf",
          url: `${config.apiURL}/uploads/articlespdfs/childVax-infographic.pdf`,
        },
        {
          type: "pdf",
          url: `${config.apiURL}/uploads/articlespdfs/infographics-strengthen-baby-immune-system-11x17-508.pdf`,
        },
        {
          type: "pdf",
          url: `${config.apiURL}/uploads/articlespdfs/Immunization-Infographic-English_092019.pdf`,
        },
      ],
    },
  ];

  return (
    <>
    <div className="Articles-digitalHealth">
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js" />

        {immunizationUrls[0].urls.map((item, index) => {
          if (item.type === "pdf") {
            return (
              <div className="articles-hyper-pdf">
                <Viewer
                  key={index}
                  fileUrl={item.url}
                  plugins={[defaultLayoutPluginInstance]}
                />
              </div>
            );
          } else if (item.type === "image") {
            return item.urls.map((imageUrl, imageIndex) => (
              <div className="articles-hyper-image">
                <img key={imageIndex} crossorigin="anonymous" src={imageUrl} />
              </div>
            ));
          } else if (item.type === "link") {
            return (
              <div className="articles-hyper-link">
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  <div>
                    <p>{item.url}</p>
                  </div>
                </a>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                {/*<img src={item.image} alt="Link Image" />*/}
              </div>
            );
          }
          return null;
        })}
      </div>
    </>
  );
};

export default immunization;
